import {BookingModel} from "../../booking.model";
import {PaymentMethodCodesEnum, PaymentMethodsSortOrder} from "./payment-method-codes.enum";
import {IServiceFactory} from "../../../../service-factory.interface";
import {PaymentMethodCategoryEnum} from "./payment-method-category.enum";
import {PspCodesEnum} from "./psp-codes.enum";
import React from "react";
import {IPaymentMethodModel} from "./payment-method.model.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {CardNetworkModel} from "./card/networks/card-network.model";

export abstract class PaymentMethodBaseModel implements IPaymentMethodModel {
    constructor(protected readonly booking: BookingModel,
                public readonly code: PaymentMethodCodesEnum,
                pspCode: PspCodesEnum,
                networks: CardNetworkModel[]) {
        this._pspCode = pspCode;
        this._networks = networks;
        makeObservable<this, '_pspCode' | '_networks'>(this, {
            _pspCode: observable.ref,
            _networks: observable.ref
        })
    }

    abstract get name(): string;
    abstract get category(): PaymentMethodCategoryEnum;
    abstract canMakePayments(): Promise<boolean>;
    abstract renderTabHeader(): React.ReactElement;
    abstract renderTabContent(): React.ReactElement;
    abstract renderPayButton(): React.ReactElement;

    protected get services(): IServiceFactory {
        return this.booking.services;
    }

    private _pspCode: PspCodesEnum;
    get pspCode(): PspCodesEnum {
        return this._pspCode;
    }

    private _networks: CardNetworkModel[];

    get networks(): CardNetworkModel[] {
        return this._networks;
    }

    update(pspCode: PspCodesEnum, supportedCardNetworks: CardNetworkModel[]): void{
        runInAction(() => {
            this._pspCode = pspCode;
            this._networks = supportedCardNetworks;
        });
    }

    getSortOrder(): number {
        return PaymentMethodsSortOrder[this.code] || 99999;
    }


}
